<template>
    <PageLoading v-if="isLoading" />
    <div v-else class="main-wrap course-learn-page">
        <div class="row">
            <div class="content col-12">
                <div class="embed-container">
                    <iframe
                        v-if="showIframe"
                        id="myframe"
                        ref="scormIframe"
                        :src="courseURL"
                        name="course"
                        frameborder="0"
                    >
                    </iframe>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PageLoading from '@/components/PageLoading'
import _ from 'lodash'
import libraryService from '@/services/modules/libraries'
import scormService from '@/services/modules/scorm'
import store from '@/store'

const loadingKeys = {
    fetchingLibrary: 'fetching-library',
    savingLibrary: 'saving-library',
}

export default {
    name: 'CourseLearn',

    components: {
        PageLoading,
    },

    data() {
        return {
            debug: true,
            library: [],
            hasCourse: false,
            libraryCourse: {},

            showIframe: false,

            courseURL: '',
            courseBaseURL: '/assets/courses/',
        }
    },

    computed: {
        isLoading() {
            return this.isFetchingLibrary
        },

        isFetchingLibrary() {
            return !!this.loadings.filter(
                (loading) => loading.key === loadingKeys.fetchingLibrary
            ).length
        },

        isSavingLibrary() {
            return !!this.loadings.filter(
                (loading) => loading.key === loadingKeys.savingLibrary
            ).length
        },

        userLogged() {
            return store.getters['session/user']
        },
    },

    async created() {
        this.courseId = this.$route.params.id

        // check if user is owner of this course (check library)
        // if not, redirects to course details and triggers notification with text to buy course
        // else continue to load course status and setup scorm window api object and course launch

        if (this.userLogged) {
            await this.fetchLibrary()
            await this.ifOwnsCourse()
            if (!this.hasCourse) {
                this.$router.push({
                    name: 'CourseDetails',
                    params: { id: this.courseId },
                })
                this.$q.notify({
                    type: 'negative',
                    message: this.$t('notify.cannot_access_course'),
                })
            }
        } else {
            this.$router.push({
                name: 'CourseDetails',
                params: { id: this.courseId },
            })
            this.$q.notify({
                type: 'negative',
                message: this.$t('errors.user_must_be_logged_in'),
            })
        }

        window.API = {
            //   SCORM RTE Functions - Initialization
            LMSInitialize: (parameter) => {
                if (this.debug) {
                    console.log('LMSInitialize (parameter) = ', parameter)
                }
                return 'true'
            },
            //   SCORM RTE Functions - Getting Values
            LMSGetValue: (varName) => {
                let varValue = _.get(window.API, varName)
                if (this.debug) {
                    console.log('LMSGetValue (' + varName + ') =', varValue)
                }
                return varValue
            },
            //   SCORM RTE Functions - Setting Values
            LMSSetValue: (varName, varValue) => {
                let currentVarValue = _.get(window.API, varName)
                if (this.debug) {
                    console.log(
                        'LMSSetValue (' + varName + ') =',
                        currentVarValue
                    )
                }
                _.set(window.API, varName, varValue)
                currentVarValue = _.get(window.API, varName)
                if (this.debug) {
                    console.log(
                        'LMSSetValue (' + varName + ') =',
                        currentVarValue
                    )
                }
                return 'true'
            },
            LMSCommit: (parameter) => {
                if (this.debug) {
                    console.log('LMSCommit (parameter) = ', parameter)
                }
                this.saveLibrary(false)
                return 'true'
            },
            //   SCORM RTE Functions - Closing The Session
            LMSFinish: (parameter) => {
                if (this.debug) {
                    console.log('LMSFinish (parameter) =', parameter)
                }
                this.saveLibrary(true)
                return 'true'
            },
            //   SCORM RTE Functions - Error Handling
            LMSGetLastError: () => {
                if (this.debug) {
                    console.log('LMSGetLastError')
                }
                return 0
            },
            //   SCORM RTE Functions - Error Handling
            LMSGetErrorString: (errorCode) => {
                if (this.debug) {
                    console.log('LMSGetErrorString (errorCode) =', errorCode)
                }
                return 'error string'
            },
            LMSGetDiagnostic(errorCode) {
                if (this.debug) {
                    console.log('LMSGetDiagnostic (errorCode) =', errorCode)
                }
                return 'diagnostic string'
            },
            cmi: {},
        }

        this.courseBaseURL = '/api/data/' + this.courseId
        //env.endpoint_frontend + '/api/data/' + this.courseId
        // this.courseBaseURL =
        //     this.courseBaseURL + 'ihrdc/IHRDC_RUSTICI_TEST_60d9ef566101a/' //golf course, dá para simular curso do CFMA
        // 'ihrdc/IHRDC_TESTS_PRODDING_60d9ef4c4d312/' //diagnotics-test
        // 'ihrdc/IHRDC_IPIMS_T39748/' //ihrdc real course
        // 'others/iseazy_scorm/' //exemplo retirado da net
        // 'cfma/business_english/' //exemplo para o CFMA

        // xml file calling and parsing

        // window.API = this.mapScorm_1_2_Progress()
        await this.getStarterCMI()
        //this.$refs.scormIframe.document.domain = 'localhost:8080'
    },

    methods: {
        async fetchLibrary() {
            this.loadingAdd(loadingKeys.fetchingLibrary)

            let parameters = {
                filter: {
                    user: this.userLogged.id,
                },
            }

            let response = await libraryService.retrieve(parameters)

            if (response.data.status === 'success') {
                this.library = response.data.results
            } else {
                this.$q.notify({
                    type: 'negative',
                    message: this.$t('errors.library_error'),
                })
            }

            this.loadingRemove(loadingKeys.fetchingLibrary)
        },

        async fetchFile(file) {
            this.loadingAdd(loadingKeys.fetchingLibrary)

            let parameters = {
                file: file,
                courseId: this.courseId,
            }

            let response = await scormService.retrieve(parameters)

            if (response.status === 200) {
                this.fileContent = response.data
            } else {
                this.$q.notify({
                    type: 'negative',
                    message: this.$t('errors.course_load_error'),
                })
            }

            this.loadingRemove(loadingKeys.fetchingLibrary)
        },

        async getStarterCMI() {
            this.loadingAdd(loadingKeys.fetchingLibrary)

            let parameters = {
                filter: {
                    id: this.courseId,
                },
            }

            let response = await scormService.retrieve(parameters)

            if (response.status === 200) {
                if (response.data.data?.length > 0) {
                    if (response.data.data[0].cmi !== null) {
                        window.API.cmi = response.data.data[0].cmi
                    }
                    this.courseURL =
                        this.courseBaseURL + '/' + response.data.data[0].starter
                }
            } else {
                this.$q.notify({
                    type: 'negative',
                    message: this.$t('errors.course_load_error'),
                })
            }

            if (window.API.cmi !== null) {
                this.showIframe = true
            }

            this.loadingRemove(loadingKeys.fetchingLibrary)
        },

        async saveLibrary(redirect) {
            this.loadingAdd(loadingKeys.savingLibrary)

            this.libraryCourse.progress = window.API.cmi
            let parameters = {
                data: [
                    {
                        user_id: this.libraryCourse.user_id,
                        course_id: this.libraryCourse.course_id,
                        progress: this.libraryCourse.progress,
                    },
                ],
            }

            let response = await libraryService.update(parameters)
            if (redirect) {
                if (response.status === 200) {
                    this.$router.push({
                        name: 'CourseDetails',
                        params: { id: this.courseId },
                    })
                    this.$q.notify({
                        type: 'positive',
                        message: this.$t('notify.course_progress_saved'),
                    })
                } else {
                    this.notifyError(response)
                }
            }

            this.loadingRemove(loadingKeys.savingLibrary)
        },

        async ifOwnsCourse() {
            if (this.library.length && this.courseId) {
                let course = this.library.find(
                    (item) => item.course_id === parseInt(this.courseId)
                )
                this.hasCourse = course ? true : false
                this.libraryCourse = course
            }
        },

        // mapScorm_1_2_Progress() {
        //     return {
        //         //   SCORM RTE Functions - Initialization
        //         LMSInitialize: (parameter) => {
        //             if (this.debug) {
        //                 console.log('LMSInitialize (parameter) = ', parameter)
        //             }
        //             return 'true'
        //         },
        //         //   SCORM RTE Functions - Getting Values
        //         LMSGetValue: (varName) => {
        //             let varValue = _.get(window.API, varName)
        //             if (this.debug) {
        //                 console.log('LMSGetValue (' + varName + ') =', varValue)
        //             }
        //             return varValue
        //         },
        //         //   SCORM RTE Functions - Setting Values
        //         LMSSetValue: (varName, varValue) => {
        //             let currentVarValue = _.get(window.API, varName)
        //             if (this.debug) {
        //                 console.log(
        //                     'LMSSetValue (' + varName + ') =',
        //                     currentVarValue
        //                 )
        //             }
        //             _.set(window.API, varName, varValue)
        //             currentVarValue = _.get(window.API, varName)
        //             if (this.debug) {
        //                 console.log(
        //                     'LMSSetValue (' + varName + ') =',
        //                     currentVarValue
        //                 )
        //             }
        //             return 'true'
        //         },
        //         LMSCommit: (parameter) => {
        //             if (this.debug) {
        //                 console.log('LMSCommit (parameter) = ', parameter)
        //             }
        //             this.saveLibrary()
        //             return 'true'
        //         },
        //         //   SCORM RTE Functions - Closing The Session
        //         LMSFinish: (parameter) => {
        //             if (this.debug) {
        //                 console.log('LMSFinish (parameter) =', parameter)
        //             }
        //             this.saveLibrary()
        //             return 'true'
        //         },
        //         //   SCORM RTE Functions - Error Handling
        //         LMSGetLastError: () => {
        //             if (this.debug) {
        //                 console.log('LMSGetLastError')
        //             }
        //             return 0
        //         },
        //         //   SCORM RTE Functions - Error Handling
        //         LMSGetErrorString: (errorCode) => {
        //             if (this.debug) {
        //                 console.log(
        //                     'LMSGetErrorString (errorCode) =',
        //                     errorCode
        //                 )
        //             }
        //             return 'error string'
        //         },
        //         LMSGetDiagnostic(errorCode) {
        //             if (this.debug) {
        //                 console.log('LMSGetDiagnostic (errorCode) =', errorCode)
        //             }
        //             return 'diagnostic string'
        //         },
        //     }
        // },
    },
}
</script>
